import React from 'react';
import { ShieldIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-slate-900 border-t border-slate-800 py-12" data-id="element-64">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-65">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-start" data-id="element-66">
          {/* Left */}
          <div className="flex flex-col space-y-4" data-id="element-67">
            <div className="flex items-center space-x-3" data-id="element-68">
              <div className="w-8 h-8 bg-emerald-600 rounded-lg flex items-center justify-center" data-id="element-69">
                <ShieldIcon className="w-5 h-5 text-white" data-id="element-70" />
              </div>
              <div className="flex flex-col" data-id="element-71">
                <span className="text-white font-bold text-lg leading-none tracking-tight" data-id="element-72">
                  Franklin County
                </span>
                <span className="text-emerald-400 text-xs font-medium tracking-wider uppercase mt-1" data-id="element-73">
                  Health Department
                </span>
              </div>
            </div>
            <p className="text-slate-400 text-sm max-w-xs" data-id="element-74">
              Powered by public health inspection data. Making food safety
              accessible and understandable for all residents.
            </p>
          </div>

          {/* Center */}
          <div className="flex flex-col space-y-3 md:items-center" data-id="element-75">
            <h4 className="text-white font-semibold mb-2" data-id="element-76">Resources</h4>
            <a href="#" className="text-slate-400 hover:text-emerald-400 text-sm transition-colors" data-id="element-77">
              Inspection Process
            </a>
            <a href="#" className="text-slate-400 hover:text-emerald-400 text-sm transition-colors" data-id="element-78">
              Report a Concern
            </a>
            <a href="#" className="text-slate-400 hover:text-emerald-400 text-sm transition-colors" data-id="element-79">
              Data API
            </a>
            <a href="#" className="text-slate-400 hover:text-emerald-400 text-sm transition-colors" data-id="element-80">
              Privacy Policy
            </a>
          </div>

          {/* Right */}
          <div className="flex flex-col space-y-4 md:items-end text-left md:text-right" data-id="element-81">
            <div className="bg-slate-800 rounded-lg p-4 border border-slate-700 max-w-xs" data-id="element-82">
              <p className="text-slate-300 text-sm font-medium mb-1" data-id="element-83">
                Data updated daily
              </p>
              <p className="text-slate-500 text-xs" data-id="element-84">
                Sourced directly from Franklin County Health Department official
                records.
              </p>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-slate-800 text-center" data-id="element-85">
          <p className="text-slate-500 text-xs max-w-3xl mx-auto" data-id="element-86">
            Disclaimer: This AI assistant provides information based on official
            inspection records and is intended for informational purposes only.
            It does not replace official health department guidance. For
            emergencies or to report immediate health hazards, please call the
            Health Department directly at (555) 012-3456.
          </p>
        </div>
      </div>
    </footer>;
}